import ApiEnterpriseLanding from '../../components/administration/api/api-enterprise-landing';
import RulesEngineEnterpriseLanding from '../../components/tools/rules-engine/rules-engine-enterprise-landing';

export const enterpriseUpsellPages = [
  {
    key: 'Rules Engine',
    label: 'Rules Engine',
    Component: RulesEngineEnterpriseLanding,
  },
  { key: 'gPanel API', label: 'gPanel API', Component: ApiEnterpriseLanding },
] as const;

export type EnterpriseUpsellPageKey =
  (typeof enterpriseUpsellPages)[number]['key'];
